import { RootStoreConfig } from '@ngrx/store';
import { META_REDUCERS } from './meta-reducers.constant';

export const STORE_CONFIGURATION: RootStoreConfig<any, any> = {
  metaReducers: META_REDUCERS,
  runtimeChecks: {
    strictStateImmutability: true,
    strictActionImmutability: true,
    strictStateSerializability: true,
    strictActionSerializability: true,
    strictActionWithinNgZone: true,
    strictActionTypeUniqueness: true
  }
};
